/**
 * Builds an accessible name for a clickable card (item/entity/place/
 * collection-item) that states what the card IS — never the generic
 * "card" or "button" a screen reader would otherwise announce (COL-91).
 *
 * Shared by ItemCard, EntityCard (Entities.jsx), PlaceCard (Places.jsx) and
 * the enrichment card in CollectionDetail.jsx so the "name — type" format
 * only has one place to change.
 *
 * @param {string} name - the card's primary label (headline/entity name/etc).
 * @param {string} [type] - a secondary descriptor (category/entity type/etc).
 * @param {object} [options]
 * @param {string} [options.fallbackName] - used when `name` is falsy.
 * @param {string} [options.fallbackType] - used when `type` is falsy.
 * @param {string} [options.omitType] - a `type` value (after fallback) that's
 *   too generic to announce, e.g. "uncategorized" — dropped instead of shown.
 */
export function cardAccessibleName(name, type, options = {}) {
  const { fallbackName = 'Untitled', fallbackType, omitType } = options;
  const resolvedName = name || fallbackName;
  const resolvedType = type || fallbackType;

  if (!resolvedType || resolvedType === omitType) {
    return resolvedName;
  }

  return `${resolvedName} — ${resolvedType}`;
}
